// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2765b174","453":"2928f792","455":"a449d396","977":"6ac02d88"}[chunkId] + ".chunk.js";
};